export const urls = {
  ContactUrl: '/contact-us',
};

export default urls;
